import PageLayout from '../../common/components/PageLayout/PageLayout'
import References from '../../common/components/References/References'
import Images from '../../common/Images'
import './Safety.css'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import TextRef from '../../common/components/TextRef/TextRef'
import ImagesCarousel from '../../common/components/ImagesCarousel/ImagesCarousel'
import MarginDecoration from '../../common/components/MarginDecoration/MarginDecoration'

function Safety () {
  const images = [Images.Safety_1, Images.Safety_2, Images.Safety_3]

  return (
    <PageLayout title="Safety">
      <MarginDecoration />
      <p>
        Our strategies have been meticulously crafted to prioritize both user
        safety and environmental responsibility. Our approach predominantly
        relies on biological materials and substances that have been recycled,
        including ethanol and polyacrylamide, methanol, isopropanol, ethanol,
        ethidium bromide, which are managed to prevent any environmental impact.
        To ensure the responsibility and ethics of our strategy, we engaged
        experts in the field to verify that the target we&apos;ve developed will
        act in the best interest without causing mutations. Professionals have
        confirmed that the project is safe and ethical.{' '}
      </p>

      <p>
        The main objective of our project is to propose a method for
        universalizing blood by removing A and B antigens. To develop this
        strategy, we used the microorganism <i> Escherichia coli </i> DH5a ,
        commonly found in global environments and classified as BSL-1 bacteria.
        All potentially hazardous chemicals were handled with the utmost care in
        a controlled environment (flow hood), and we strictly adhered to general
        laboratory safety protocols throughout our work.
      </p>

      <ImagesCarousel images={images} />

      <p>
        All experiments conducted followed standard procedures, including
        protein electrophoresis, DNA electrophoresis, DNA extraction, kinetic
        studies of our enzyme, and rheology analysis. Among the various
        protocols employed, we utilized ethidium bromide. It&apos;s important to
        note that ethidium bromide is a well-known carcinogenic and mutagenic
        substance. Polyacrylamide is a toxic substances.Consequently, our team
        members received comprehensive training prior to handling it, ensuring
        that we minimized the associated risks.
      </p>

      <p>
        {' '}
        Throughout the project, we maintained a rigorous commitment to safety
        within our laboratory. We had experts overseeing the safety protocols
        <TextRef sup="1" content="" />, ensuring that our workspace adhered to
        both national and university safety standards. Every experiment
        completed in the lab was conducted under the supervision of a
        professional with extensive experience in the field. Moreover, we had a
        variety of risk management measures at our disposal, including access to
        accident reports, personal protective equipment, a secure storage area
        for our laboratory equipment, and a robust waste management system in
        place. Additionally, we prioritized ergonomic work practices to ensure
        the safety and well-being of our team members, adapting our work
        postures to minimize health risks <TextRef sup="2" content="" />.
      </p>

      <p>
        {' '}
        The iGEM Ulaval team is firmly committed to championing sustainable
        health initiatives, drawing inspiration from recent charters such as the
        Okanagan Charter <TextRef sup="3" content="" />. This charter serves as
        a guiding force for our team&apos;s actions, positioning us as pioneers
        in sustainable health within the Francophone community.{' '}
      </p>

      <References
        references={[
          <span key={1}>
            https://www.ssp.ulaval.ca/matieres-dangereuses/guide-de-securite-en-laboratoire/
          </span>,
          <span key={2}>
            https://www.scccul.ulaval.ca/wp-content/uploads/2021/02/Convention_collective_SCCCUL_2019_2022_V2_25_01_2021.pdf
          </span>,
          <span key={3}>
            https://www.ulaval.ca/sante-durable/charte-de-lokanagan
          </span>
        ]}
      />
    </PageLayout>
  )
}

export default Safety
